/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

import { KTDatepicker } from './datepicker';
import * as DatepickerTypes from './types';

export { KTDatepicker, DatepickerTypes };
export default KTDatepicker;
